import { ISelectOption } from '@/components/form/fields/SelectField';
import { EnumUtil } from '@/utils/libs/enumUtil';

export const customFieldType: ISelectOption[] = [
  { value: 'CHECK_BOXES', label: 'Check Boxes' },
  { value: 'SELECT_DROPDOWN', label: 'Select Dropdown' },
  { value: 'RADIO_BUTTONS', label: 'Radio Buttons' },
  { value: 'INPUT_FIELDS', label: 'Input Fields' },
  { value: 'TEXT_AREA_FIELDS', label: 'Text Area Fields' },
  { value: 'MULTI_SELECT', label: 'Multi Select' },
  { value: 'URL_LINK_INPUT', label: 'Url Link Input' },
];

export const customFieldTypeOptions = customFieldType.map(option => ({
  ...option,
  isHaveOption:
    option.value === 'CHECK_BOXES' ||
    option.value === 'SELECT_DROPDOWN' ||
    option.value === 'RADIO_BUTTONS' ||
    option.value === 'MULTI_SELECT',
}));

export class ModuleType extends EnumUtil {
  public static readonly TEST_CASES = 'TEST_CASES';
  public static readonly ISSUES = 'ISSUES';
  public static readonly TEST_RUN = 'TEST_RUN';
  public static readonly ADD_TEST_RUN = 'ADD_TEST_RUN';
}

export const moduleTypeOptions: ISelectOption[] = [
  { value: ModuleType.TEST_CASES, label: 'Test Cases' },
  { value: ModuleType.ISSUES, label: 'Issues' },
  { value: ModuleType.TEST_RUN, label: 'Test Run' },
  { value: ModuleType.ADD_TEST_RUN, label: 'Add Test Run' },
];
